import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { CategoryScale, LinearScale, PointElement, LineElement, Chart, Tooltip } from 'chart.js';
import type { ChartOptions, ChartData } from 'chart.js';
import { Row, YTDTrend } from './Types';
import { Dialog, DialogTitle } from '@mui/material';
import annotationPlugin from 'chartjs-plugin-annotation';

Chart.register(CategoryScale, PointElement, LinearScale, LineElement, Tooltip, annotationPlugin);

export const TrendChart = (props: YTDTrend & { dialogTitle: string, satisfactoryLimit: number, unit: Row['units'] }) => {
    const [dialogOpen, setDialogOpen] = useState(false);

    const data: ChartData<'line'> = {
        labels: props.months,
        datasets: [
            {
                data: props.data,
                borderColor: 'rgba(0, 0, 0, 0.80)',
                fill: false
            }
        ]
    };

    const options: ChartOptions<'line'> = {
        responsive: true,
        elements: {
            line: {
                borderWidth: 1
            },
            point: {
                radius: 0
            }
        },
        scales: {
            x: { display: false },
            y: { display: false }
        }
    };


    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const onLineClick = () => {
        setDialogOpen(true);
    };

    return (
        <>
            <Line onClick={onLineClick} options={options} data={data}></Line>
            <Dialog onClose={handleDialogClose} open={dialogOpen} sx={{
                padding: 2
            }}>
                <DialogTitle>{props.dialogTitle}</DialogTitle>
                <Line
                    data={data}
                    options={{
                        responsive: true,
                        scales: {
                            y: {
                                beginAtZero: true,
                                ...(props.unit === 'Percentage' && {
                                    max: 100,
                                })
                            }
                        },
                        hover: {
                            axis: 'xy',
                            mode: 'point'
                        },
                        plugins: {
                            tooltip: {
                                enabled: true
                            },
                            annotation: {
                                annotations: {
                                    line1: {
                                        type: 'line',
                                        yMin: props.satisfactoryLimit,
                                        yMax: props.satisfactoryLimit,
                                        borderColor: '#2e7d32',
                                        borderWidth: 2,
                                        borderDash: [7]
                                    }
                                }
                            }
                        }
                    }}
                    style={{
                        margin: '1em',
                        height: 'inherit',
                        width: 'inherit',
                    }} />
            </Dialog>
        </>
    );
};

export const YTDTrendRenderer = (props: GridRenderCellParams<Row, YTDTrend>) => {

    const value = props.value;
    if (props.row.isHeader || props.row.satisfactoryLimit === undefined || value === undefined) {
        return <></>;
    } else {
        const dialogTitle = `${props.row.code}: ${props.row.description}`;
        return <TrendChart
            {...value}
            dialogTitle={dialogTitle}
            satisfactoryLimit={props.row.satisfactoryLimit}
            unit={props.row.units}
        />;
    }
};
